import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosConfig from '../../../configs/axios.config';
import axios from 'axios'

//Reducer Thunk
export const getItemDocument = createAsyncThunk('DocumentMasterData/GetItemDocument',
    async () => {
        try {
            const response = await axios.create(axiosConfig).get('api/DocumentMaterData/GetItemInfoData')
            if (response.data.success) {
                return response.data.result
            }
            else {
                console.log(response.data)
            }
        }
        catch (error) {
            console.log(error)
        }
    })

const DocumentMasterDataSlice = createSlice({
    name: 'DocumentMasterData',
    initialState: {
        documentItemInfoData: null,
        Loading: true
    },
    reducers: {
        resetDocumentItemInfoData(state, action) {
            state.documentItemInfoData = null;
        }
    },
    extraReducers: (builder) => { 
        builder.addCase(getItemDocument.fulfilled, (state, action) => {
            state.Loading = false
            state.documentItemInfoData = action.payload
        })
    }
})

//Reducer
const DocumentMasterDataReducer = DocumentMasterDataSlice.reducer

//Selector
export const DocumentMasterDataSelector = (state) => state.DocumentMasterDataReducer

//Action export
export const {

} = DocumentMasterDataSlice.actions

//Export reducer
export default DocumentMasterDataReducer